import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = `
Política de Privacidad — Rescate de Pareja: Post-Crisis

Última actualización: Abril 2026

1. Información que recopilamos
Recopilamos únicamente la información necesaria para procesar tu compra: nombre, dirección de correo electrónico y datos de pago. No almacenamos datos de tarjetas de crédito directamente; estos son procesados por nuestro proveedor de pagos seguro.

2. Uso de la información
Tu información personal se utiliza exclusivamente para:
• Procesar y entregar tu compra digital
• Enviarte el material adquirido por correo electrónico
• Comunicarnos contigo en caso de problemas con tu pedido

3. Protección de datos
Implementamos medidas de seguridad técnicas y organizativas para proteger tu información personal contra acceso no autorizado, alteración o destrucción.

4. Compartir información
No vendemos, intercambiamos ni transferimos tu información personal a terceros. La única excepción son los proveedores de servicios que nos ayudan a operar nuestro sitio y procesar pagos, quienes están obligados a mantener la confidencialidad.
`.trim();
const termsContent = `
Términos y Condiciones — Rescate de Pareja: Post-Crisis

Última actualización: Abril 2026

1. Aceptación de los términos
Al adquirir y utilizar este producto digital, aceptás estos términos y condiciones en su totalidad. Si no estás de acuerdo, no realices la compra.

2. Descripción del producto
"Rescate de Pareja: Post-Crisis" es un producto digital (eBook en formato PDF) que incluye guías, plantillas y herramientas para mejorar la comunicación en pareja. No constituye asesoramiento psicológico, terapéutico ni profesional.

3. Entrega del producto
El producto se entrega de forma digital e inmediata tras confirmar el pago. Recibirás un enlace de descarga y/o el material por correo electrónico.

4. Política de reembolso
Ofrecemos una garantía de 7 días. Si el contenido no te aporta valor, puedes solicitar la devolución total de tu dinero dentro de este plazo.

5. Uso permitido
El material es para uso personal. Queda prohibida la reproducción, distribución, reventa o publicación del contenido, total o parcial, sin autorización expresa.
`.trim();
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-[#0D002B] py-20 border-t border-[#7C3AED]/30 pb-32 md:pb-20" data-id="element-202" data-mp="1hkfeut4pbm6h">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-203" data-mp="1mk1rp1gmb0er">
          <div className="mb-20" data-id="element-204" data-mp="1mkjvqk9iuix8">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4 font-serif" data-id="element-205" data-mp="1riv9h62xtdkq">
              ¿Listo para empezar el rescate?
            </h3>
            <p className="text-[#A78BFA] mb-10 font-sans" data-id="element-206" data-mp="3ocpyfksh05za">
              Descarga inmediata · Garantía 7 días · Pago único
            </p>
            <a href="https://clavedepaz.com/cart/44108367659107:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-block bg-[#F5C518] text-black px-10 py-5 rounded-xl text-lg font-extrabold shadow-[0_10px_30px_-5px_rgba(245,197,24,0.5)] hover:bg-[#e6b800] transition-colors font-sans tracking-wide" data-id="element-207" data-mp="2af3rlmvaexi1">
              SÍ, QUIERO ACCEDER AL PLAN
            </a>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-6 pt-10 border-t border-[#7C3AED]/30" data-id="element-208" data-mp="2tbn48m5av3jc">
            <p className="text-[#A78BFA] text-sm font-sans" data-id="element-209" data-mp="2kcrzlehwm1i5">
              © 2026 Rescate de Pareja: Post-Crisis. Todos los derechos
              reservados.
            </p>
            <div className="flex items-center gap-6" data-id="element-210" data-mp="2fgkoz8ekc1tv">
              <button onClick={() => setActiveModal('privacy')} className="text-[#A78BFA] hover:text-white text-sm transition-colors font-sans" data-id="element-211" data-mp="18yxn17iapc76">
                Política de Privacidad
              </button>
              <button onClick={() => setActiveModal('terms')} className="text-[#A78BFA] hover:text-white text-sm transition-colors font-sans" data-id="element-212" data-mp="2wmfz8vevrnf0">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-213" data-mp="3bj70zbc11b7s">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-214" data-mp="3bki2t5lww8w9">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-[#1A0050] rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden border border-[#7C3AED]/30" onClick={e => e.stopPropagation()} data-id="element-215" data-mp="1v603wq90rqxe">
              <div className="flex items-center justify-between p-6 border-b border-[#7C3AED]/30" data-id="element-216" data-mp="zuad8oolo4a3">
                <h3 className="text-xl font-bold text-white font-serif" data-id="element-217" data-mp="1dpmfri8zyz1k">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="w-10 h-10 rounded-full bg-[#0D002B] flex items-center justify-center hover:bg-[#7C3AED]/20 transition-colors" data-id="element-218" data-mp="g8xj02ywmmz1">
                  <XIcon className="w-5 h-5 text-[#C4B5FD]" data-id="element-219" data-mp="2l85j7y2ducaw" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-220" data-mp="2q0ymehi7dckv">
                <div className="prose prose-sm max-w-none font-sans" data-id="element-221" data-mp="2uyi2lmygnzfg">
                  {(activeModal === 'privacy' ? privacyContent : termsContent).split('\n').map((line, i) => {
                if (!line.trim()) return <div key={i} className="h-3" data-id="element-222" data-mp="279ytx6bi1kmu" />;
                if (/^\d+\./.test(line.trim())) {
                  return <h4 key={i} className="text-lg font-bold text-white mt-6 mb-2" data-id="element-223" data-mp="2bclnpcrqdfmo">
                            {line}
                          </h4>;
                }
                if (line.startsWith('Política') || line.startsWith('Términos')) {
                  return <h4 key={i} className="text-lg font-bold text-[#C4B5FD] mb-1" data-id="element-224" data-mp="12a8z3l9dk74c">
                            {line}
                          </h4>;
                }
                if (line.startsWith('Última')) {
                  return <p key={i} className="text-sm text-[#A78BFA] mb-4" data-id="element-225" data-mp="jc6i9tqzdghm">
                            {line}
                          </p>;
                }
                if (line.startsWith('•')) {
                  return <p key={i} className="text-[#E0D7FF] pl-4 mb-1" data-id="element-226" data-mp="2do4ornxwny9t">
                            {line}
                          </p>;
                }
                return <p key={i} className="text-[#E0D7FF] mb-2 leading-relaxed" data-id="element-227" data-mp="1mkvag8pkewjl" data-mpi={i}>
                          {line}
                        </p>;
              })}
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}